import React from 'react'
import { storiesOf } from '@storybook/react'

import EventRules from 'components/EventRules'

storiesOf('EventRules', module)
  .add('default', () => (
    <EventRules />
  ))
  .add('simpliest fill', () => (
    <EventRules
      contest={{
        title: 'Simple',
        startTime: Math.floor(Date.now() / 1000),
        endTime: Math.floor(Date.now() / 1000) + 100000,
      }}
    />
  ))
  .add('with entry fee', () => (
    <EventRules
      contest={{
        title: 'Simple',
        startTime: Math.floor(Date.now() / 1000),
        endTime: Math.floor(Date.now() / 1000) + 100000,
        entryFee: { value: 100, currency: 0 },
      }}
    />
  ))
  .add('with max participants', () => (
    <EventRules
      contest={{
        title: 'Simple',
        startTime: Math.floor(Date.now() / 1000),
        endTime: Math.floor(Date.now() / 1000) + 100000,
        entryFee: { value: 100, currency: 0 },
        maxParticipants: 100,
      }}
    />
  ))
  .add('with matches', () => (
    <EventRules
      contest={{
        title: 'Simple',
        startTime: Math.floor(Date.now() / 1000),
        endTime: Math.floor(Date.now() / 1000) + 100000,
        entryFee: { value: 100, currency: 0 },
        maxParticipants: 100,
      }}
      matches={[{
        homeTeam: { name: 'Manchester United' },
        awayTeam: { name: 'Chelsea' },
      }, {
        homeTeam: { name: 'Juventus' },
        awayTeam: { name: 'Tottenham' },
      }]}
    />
  ))
  .add('with prize pool', () => (
    <EventRules
      contest={{
        title: 'Simple',
        startTime: Math.floor(Date.now() / 1000),
        endTime: Math.floor(Date.now() / 1000) + 100000,
        entryFee: { value: 100, currency: 0 },
        maxParticipants: 100,
      }}
      prizePool={[{
        fromRank: 1,
        toRank: 1,
        prize: [{
          money: { value: 1000, currency: 0 },
        }, {
          product: { title: 'Play Station 4 Pro', quantity: 1 },
        }]
      }, {
        fromRank: 2,
        toRank: 10,
        prize: [{
          money: { value: 100, currency: 0 },
        }]
      }]}
      matches={[{
        homeTeam: { name: 'Manchester United' },
        awayTeam: { name: 'Chelsea' },
      }, {
        homeTeam: { name: 'Juventus' },
        awayTeam: { name: 'Tottenham' },
      }]}
    />
  ))
  .add('with competitions', () => (
    <EventRules
      contest={{
        title: 'Simple',
        startTime: Math.floor(Date.now() / 1000),
        endTime: Math.floor(Date.now() / 1000) + 100000,
        entryFee: { value: 100, currency: 0 },
        maxParticipants: 100,
      }}
      prizePool={[{
        fromRank: 1,
        toRank: 1,
        prize: [{
          money: { value: 1000, currency: 0 },
        }, {
          product: { title: 'Play Station 4 Pro', quantity: 1 },
        }]
      }, {
        fromRank: 2,
        toRank: 10,
        prize: [{
          money: { value: 100, currency: 0 },
        }]
      }]}
      competitions={[{
        name: 'Premier League'
      }, {
        name: 'Bundesliga'
      }]}
      matches={[{
        homeTeam: { name: 'Manchester United' },
        awayTeam: { name: 'Chelsea' },
      }, {
        homeTeam: { name: 'Juventus' },
        awayTeam: { name: 'Tottenham' },
      }, {
        homeTeam: { name: 'BVB' },
        awayTeam: { name: 'Schalke' },
      }]}
    />
  ))
  .add('with teams', () => (
    <EventRules
      contest={{
        title: 'Simple',
        startTime: Math.floor(Date.now() / 1000),
        endTime: Math.floor(Date.now() / 1000) + 100000,
        entryFee: { value: 100, currency: 0 },
        maxParticipants: 100,
      }}
      prizePool={[{
        fromRank: 1,
        toRank: 1,
        prize: [{
          money: { value: 1000, currency: 0 },
        }, {
          product: { title: 'Play Station 4 Pro', quantity: 1 },
        }]
      }, {
        fromRank: 2,
        toRank: 10,
        prize: [{
          money: { value: 100, currency: 0 },
        }]
      }]}
      competitions={[{
        name: 'Premier League'
      }, {
        name: 'Bundesliga'
      }]}
      teams={[{
        name: 'Manchester United',
      }, {
        name: 'Chelsea',
      }, {
        name: 'Juventus',
      }, {
        name: 'Tottenham',
      }, {
        name: 'BVB',
      }, {
        name: 'Schalke',
      }]}
      matches={[{
        homeTeam: { name: 'Manchester United' },
        awayTeam: { name: 'Chelsea' },
      }, {
        homeTeam: { name: 'Juventus' },
        awayTeam: { name: 'Tottenham' },
      }, {
        homeTeam: { name: 'BVB' },
        awayTeam: { name: 'Schalke' },
      }]}
    />
  ))
